import { useEffect, useMemo } from 'react';
import { TableController } from 'bs-unified-ui';
import { useLocation } from 'react-router-dom';
import { fromQueryString } from '~/utils/queryString';

const { useController, Mode } = TableController;

const ModeSetting = () => {
  const { setMode } = useController();
  const location = useLocation();

  const filtersFromLocation = useMemo(
    () =>
      fromQueryString(location.search, {
        arrayFormat: 'none',
      }),
    [location.search],
  );

  useEffect(() => {
    if (
      Object.keys(filtersFromLocation).length &&
      filtersFromLocation?.search
    ) {
      setMode(Mode.Search);
    } else {
      setMode(Mode.Default);
    }
  }, [filtersFromLocation]);

  return null;
};

export default ModeSetting;
